import 'react-day-picker/style.css';
import styled, { css } from 'styled-components';
import { pxToRem, weightToNumber } from '../../../../../design-tokens/style-utilities';
import { FALLBACK_FONTS } from '../../../../../design-tokens/theme';
export const reactDayPickerOverrideStyles = ({ theme, $isStandalone, }) => css `
	.rdp-root {
		--rdp-day_button-border-radius: ${pxToRem(theme.borderRadius.m)};
		--rdp-today-color: ${theme.colors.base.textBody};
		--rdp-selected-border: ${theme.borderWidth['2']}px solid ${theme.colors.medium.borderFormField};
		/* Nav should be the same size as the Select fields of the Dropdown components */
		--rdp-nav-height: ${pxToRem(56)};
		--rdp-accent-color: ${theme.colors.highlight.iconInteractive};

		background-color: ${theme.colors.extralight.bgDaypicker};
		border-radius: ${pxToRem(theme.borderRadius.m)};
		border: ${theme.borderWidth['2']}px solid ${theme.colors.medium.borderFormField};
		overflow: hidden;
		padding-top: ${pxToRem(theme.spacing['100'])};
		font-family: ${[theme.typography.paragraphs['100BodyText'].fontFamily, ...FALLBACK_FONTS].join(',')};
		font-weight: ${weightToNumber(theme.typography.paragraphs['100BodyText'].fontWeight)};
		font-size: ${pxToRem(theme.typography.paragraphs['100BodyText'].fontSize)};
		line-height: ${pxToRem(theme.typography.paragraphs['100BodyText'].lineHeight)};

		${!$isStandalone &&
    css `
			position: absolute;
			top: calc(100% - ${pxToRem(theme.spacing['300'])});
			/* 100% is the height of the wrapper. 16px are additional field margins + the margin between the field and the picker */
			left: 0;
			z-index: ${Number(theme.zIndex.sticky) - 1};
		`}

		.rdp-month .rdp-month_caption {
			padding-left: ${pxToRem(theme.spacing['200'])};
		}

		.rdp-nav {
			padding-right: ${pxToRem(theme.spacing['200'])};
		}

		table {
			background: ${theme.colors.blanc.bgDaypicker};

			thead {
				background-color: ${theme.colors.extralight.bgDaypicker};

				.rdp-weekday {
					font-family: ${[
    theme.typography.heading7['75LabelTitle'].fontFamily,
    ...FALLBACK_FONTS,
].join(',')};
					font-weight: ${weightToNumber(theme.typography.heading7['75LabelTitle'].fontWeight, theme.typography.heading7['75LabelTitle'].fontFamily)};
					font-size: ${pxToRem(theme.typography.heading7['75LabelTitle'].fontSize)};
					line-height: ${pxToRem(theme.typography.heading7['75LabelTitle'].lineHeight)};
				}
			}

			tbody {
				.rdp-today {
					color: ${theme.colors.base.textBody};
					font-family: ${[
    theme.typography.heading6['100CurrentStateText'].fontFamily,
    ...FALLBACK_FONTS,
].join(',')};
					font-weight: ${weightToNumber(theme.typography.heading6['100CurrentStateText'].fontWeight)};
					font-size: ${pxToRem(theme.typography.heading6['100CurrentStateText'].fontSize)};
				}

				.rdp-day:not(.rdp-range_middle) .rdp-selected button {
					background: ${theme.colors.base.bgDaypickerSelected};
					color: ${theme.colors.blanc.textInverse};
					border-color: transparent;
				}
			}
		}
	}
`;
/**
 * DateInput container
 */
export const dateInputContainerStyles = ({ theme }) => css `
	position: relative;
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: ${pxToRem(theme.spacing['200'])};
	width: 100%;
`;
export const DateInputContainer = styled.div `
	${reactDayPickerOverrideStyles}
	${dateInputContainerStyles}
`;
/**
 * DateInput calendar trigger
 */
export const dateInputCalendarTriggerStyles = ({ theme, $colorContext, }) => css `
	display: flex;
	align-items: center;
	justify-content: flex-start;
	height: 100%;
	width: ${pxToRem(30)};
	padding: 0;
	background-color: transparent;
	border: none;
	border-radius: 0;
	cursor: pointer;
	color: ${theme.colors.highlight.iconInteractive};

	&:focus,
	&:hover {
		color: ${theme.colors.highlight.iconHover};
	}

	${$colorContext === 'on-dark' &&
    css `
		color: ${theme.colors.blanc.iconInteractiveInverse};

		&:hover {
			color: ${theme.colors.medium.iconInverseHover};
		}

		&:focus {
			color: ${theme.colors.blanc.iconInteractiveInverse};
		}
	`}

	&&& {
		&[disabled] {
			opacity: unset;
			color: ${theme.colors.medium.iconInactive};
			cursor: not-allowed;
		}
	}
`;
export const DateInputCalendarTrigger = styled.button `
	${dateInputCalendarTriggerStyles}
`;
